import { ProductBridge } from "@tablescape/utilities";
import { component } from "picoapp";
import { TablescapeContext, TablescapeEvent } from "@tablescape/context";
import { type Context } from "@root/tablescape/state";

const clearProductContext = (context: Context) => {
  const currentState = context.getState();

  if (!currentState.products) {
    return;
  }

  const clearedProducts = Object.keys(currentState.products).reduce(
    (acc, key) => ({
      ...acc,
      ...{ [key]: undefined },
    }),
    {}
  );

  TablescapeContext.emit(TablescapeEvent.PRODUCT_METADATA_CLEARED, {
    products: clearedProducts,
  });

  context.hydrate({
    ...currentState,
    products: clearedProducts,
  });
};

export const sizeSelectors = component<Context>(
  (node: HTMLElement, context) => {
    const sizeLinks = node.querySelectorAll<HTMLElement>(
      "[data-tbsp-component='segmentedControl'] a"
    );

    if (!sizeLinks.length) {
      return;
    }

    clearProductContext(context);
    const ProductURL = new ProductBridge();

    const pushToProduct = (e: MouseEvent) => {
      e.preventDefault();
      const [, productHandle] = (<HTMLAnchorElement>e.currentTarget).href.split(
        "/products/"
      );
      ProductURL.push(productHandle);
      const productTitle = node.getAttribute(
        `data-mtr-product-${productHandle}`
      );

      window.maestro.fireTrackEvent("clickSizeSelector", {
        "from url": window.location.href,
        "from path": window.location.pathname,
        "product name": productTitle,
        "product size": (<HTMLAnchorElement>e.currentTarget).innerText,
      });
    };
    [...sizeLinks].forEach((anchorElement) => {
      anchorElement.addEventListener("click", pushToProduct);
    });

    return () => {
      [...sizeLinks].forEach((anchorElement) => {
        anchorElement.removeEventListener("click", pushToProduct);
      });

      ProductURL.destroy();
    };
  }
);
